import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import LoginIcon from '@mui/icons-material/Login';

function Footer() {
  return (
    <footer className="footer" style={{ display: 'flex', justifyContent: 'space-around', padding: '10px', backgroundColor: 'rgb(31 31 31)' }}>
      <Link to="/" style={{ textAlign: 'center', textDecoration: 'none', color: 'inherit' }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <HomeIcon />
          <Typography variant="caption">Home</Typography>
        </Box>
      </Link>
      <Link to="/movie" style={{ textAlign: 'center', textDecoration: 'none', color: 'inherit' }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <VideocamOutlinedIcon />
          <Typography variant="caption">Movies</Typography>
        </Box>
      </Link>
      <Link to="/social" style={{ textAlign: 'center', textDecoration: 'none', color: 'inherit' }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <LanguageOutlinedIcon />
          <Typography variant="caption">Social</Typography>
        </Box>
      </Link>
      {/* <Link to="/login" style={{ textAlign: 'center', textDecoration: 'none', color: 'inherit' }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <LoginIcon />
          <Typography variant="caption">Login</Typography>
        </Box>
      </Link> */}
    </footer>
  );
}

export default Footer;